import { BottomScrollListener } from '@ami/react/core';
import Row from './QuoteTableRow';
import { SearchQuoteResult as Quote } from './searchQuotes';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const Table = ({ quotes, loading, onBottomScroll }) => {
  const rows = quotes.map((x) => <Row quote={x} key={x.id} />);
  return (
    <div className="recent-list-wrapper">
      <ul className="list-unstyled">
        <BottomScrollListener onBottom={onBottomScroll}>
          <Fragment>
            {rows}
            {(loading || rows.length === 0) && <hr />}
            {loading && (
              <span>
                Loading... <i className="fa fa-spin fa-spinner" />
              </span>
            )}
            {!loading && rows.length === 0 && <span>No data found</span>}
          </Fragment>
        </BottomScrollListener>
      </ul>
    </div>
  );
};

Table.propTypes = {
  quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote)).isRequired,
  loading: PropTypes.bool.isRequired,
  onBottomScroll: PropTypes.func.isRequired,
};

export default Table;
